/* tslint:disable:function-name interface-name no-any */
/**
 * @file Provides replacements for Angular specific interfaces and decorators.
 */

export declare interface OnDestroy {
  /**
   * A callback method that performs custom clean-up, invoked immediately
   * before a directive, pipe, or service instance is destroyed.
   */
  ngOnDestroy(): void;
}

export declare interface ModuleWithProviders<T> {
  ngModule: any;
  providers?: any[];
}

export function NgModule(_args: unknown): any {
  return (_constructor: Function): any => {
  };
}
